// React Dependencies
import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";

// Components
import App from "./app/App";

// Antd Styles
import "antd/dist/antd.css";

// Redux store
import store from "./store";

const MainApp = (props) => {
  return (
    <Provider store={store}>
      <App {...props} />
    </Provider>
  );
};

const htmlTarget = document.getElementById("root");
ReactDOM.render(<MainApp />, htmlTarget);
